module.exports = __webpack_public_path__ + "static/media/node.f8dab57d.png";